import { useLayoutEffect, useRef, useState } from "react";
import type { ImgHTMLAttributes } from "react";
import {
  readAnnotations,
  DEFAULT_REFERENCE_WIDTH,
} from "../../shared/photo-annotations/annotationMigrate";
import { AnnotationLayer } from "./AnnotationLayer";
import { containRect } from "../../shared/photo-annotations/annotationGeometry";

/** Measure the actual contained image, never the lightbox or thumbnail crop. */
export function AnnotatedPhoto({
  annotations,
  showAnnotations,
  onLoad,
  ...props
}: ImgHTMLAttributes<HTMLImageElement> & {
  annotations: unknown;
  showAnnotations: boolean;
}) {
  const ref = useRef<HTMLImageElement>(null);
  const [size, setSize] = useState({ w: 0, h: 0, aspect: 0 });
  const measure = () => {
    const image = ref.current;
    if (image?.naturalWidth)
      setSize({
        w: image.clientWidth,
        h: image.clientHeight,
        aspect: image.naturalWidth / image.naturalHeight,
      });
  };
  useLayoutEffect(() => {
    measure();
    const observer = new ResizeObserver(measure);
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [props.src]);
  const doc = readAnnotations(annotations, {
    screenWidth: DEFAULT_REFERENCE_WIDTH,
    imageAspect: size.aspect || null,
  });
  return (
    <div style={{ position: "relative", display: "flex" }}>
      <img
        {...props}
        ref={ref}
        onLoad={(event) => {
          measure();
          onLoad?.(event);
        }}
      />
      {showAnnotations && size.w > 0 && (
        <AnnotationLayer
          doc={doc}
          rect={containRect(size.w, size.h, size.aspect)}
          width={size.w}
          height={size.h}
        />
      )}
    </div>
  );
}
